export default {
    data() {
        return {
            sort: {
                key: 'name',
                direction: 'asc',
            },
        };
    },
    methods: {
        sortByKeyAndDirection(a, b) {
            if (this.sort.key === 'name') {
                if (this.sort.direction === 'asc') {
                    if (a.name < b.name) { return -1; }
                    if (a.name > b.name) { return 1; }
                }
                if (this.sort.direction === 'desc') {
                    if (a.name > b.name) { return -1; }
                    if (a.name < b.name) { return 1; }
                }
                return 0;
            }

            if (this.sort.key === 'publishedDate') {
                if (this.sort.direction === 'asc') {
                    if (a[this.sort.key] === null || b[this.sort.key] === null) {
                        return 1;
                    }
                    if (new Date(a[this.sort.key]) > new Date(b[this.sort.key])) return 1;
                    if (new Date(a[this.sort.key]) < new Date(b[this.sort.key])) return -1;
                    return 0;
                }

                if (a[this.sort.key] === null || b[this.sort.key] === null) {
                    return -1;
                }
                if (new Date(a[this.sort.key]) < new Date(b[this.sort.key])) return 1;
                if (new Date(a[this.sort.key]) > new Date(b[this.sort.key])) return -1;
                return 0;
            }

            if (this.sort.key === 'nextPublishedDate') {
                const dateA = new Date(a[this.sort.key]); // merge the date & time
                const dateB = new Date(b[this.sort.key]); // depending on the format

                if (!a[this.sort.key] && b[this.sort.key]) return 1;
                if (a[this.sort.key] && !b[this.sort.key]) return -1;
                if (dateA === dateB) return 0;

                if (this.sort.direction === 'asc') {
                    if (dateA > dateB) return 1;
                    if (dateB > dateA) return -1;
                    return 0;
                }

                if (dateA > dateB) return -1;
                if (dateB > dateA) return 1;
                return 0;
            }

            return 0;
        },
    },
};
